/* global MOCK_ENABLE */
import * as urls from './urls';

function isTruthyMockSwitch(value) {
  return value === true || value === 'true' || value === 1 || value === '1';
}

const deployEnv = typeof DEPLOY_ENV === 'undefined' ? '' : DEPLOY_ENV;
const href = window && window.location ? window.location.href : '';
const buildMockEnable = typeof MOCK_ENABLE !== 'undefined' && isTruthyMockSwitch(MOCK_ENABLE);
const windowMockEnable = isTruthyMockSwitch(window.MOCK_ENABLE);
const isNonMaster = deployEnv !== 'master';

const constants = {
  urls,
  MOCK_ENABLE: isNonMaster && (buildMockEnable || windowMockEnable),
  IS_MOCK_ON: isNonMaster && (href.indexOf('__MOCK__') > -1 || buildMockEnable || windowMockEnable)
};

//是否正式环境
export const isProduction = deployEnv === 'master';

export default constants;
